import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Close from "../../../assets/images/close-icon.png";
import {
  pauseCampaign,
  closeCampaign,
  shareCampaign,
} from "../../../utils/campaignViewActions";

/**
 * ActiveActions — Post-publication transitions
 * Backend: update-campaign-status (superAdmin.controller.js:1428)
 */
const ActiveActions = ({ campaign, campaignId, setLoading, canEdit }) => {
  const navigate = useNavigate();
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const resolvedCampaignId = campaignId || campaign?.data?.[0]?.id;

  // QA 2026-07-28 F-1 (beyond the four handlers the report named): pause and
  // close both open a confirmation dialog, and the page-level loader was raised
  // before it - covering the Swal and eating the click. These act on LIVE
  // campaigns. `confirmAction` supplies SweetAlert's own inline spinner for the
  // network phase, so the outer loader was redundant here too.
  const handlePause = async () => {
    const result = await pauseCampaign(resolvedCampaignId);
    if (result.success && result.navigateTo) navigate(result.navigateTo);
  };

  const handleClose = async () => {
    const result = await closeCampaign(resolvedCampaignId);
    if (result.success && result.navigateTo) navigate(result.navigateTo);
  };

  // shareCampaign keeps its loader: it opens no dialog, so the overlay wraps
  // only the network call. (The launch-date control that used to sit beside it
  // moved to CampaignSchedulePanel, which shows it on every status rather than
  // only on this one — QA 2026-07-31 §B.4.)
  const onShareSubmit = async (data) => {
    setLoading(true);
    await shareCampaign(data.email, resolvedCampaignId);
    setLoading(false);
    setShareModalOpen(false);
  };

  return (
    <div className="left">
      <div className="title-topSection">
        <h1 className="title">Campaign Actions</h1>
        {/* Shown to whoever reaches this panel, as before F22: staff seats never get it (CampaignViewPage
            renders no action panel for them), and gating it on canEdit hid it from an AD whose shadow lacks the
            queue's write grant (Codex admin review). */}
        <button className="approveButton" onClick={() => setShareModalOpen(true)}>
          Share Campaign
        </button>
      </div>

      {/* QA 2026-09-07 (F22): writes need the queue's :Edit grant */}
      {canEdit !== false && (
      <div style={{ display: "flex", gap: "10px", marginTop: "10px", marginBottom: "16px" }}>
        <button className="approveButton paseCampBtn" onClick={handlePause}>
          Pause Campaign
        </button>
        <button className="approveButton" onClick={handleClose}>
          Close Campaign
        </button>
      </div>
      )}

      {/* Share Modal */}
      <Modal open={shareModalOpen} onClose={() => setShareModalOpen(false)}>
        <Box className="modal-popup">
          <div className="modal-top">
            <Typography variant="h6" component="h2">
              Share Campaign
            </Typography>
            <Button className="closeBtn" onClick={() => setShareModalOpen(false)}>
              <img src={Close} alt="close-icon" />
            </Button>
          </div>
          <form onSubmit={handleSubmit(onShareSubmit)} style={{ padding: "16px" }}>
            <div style={{ marginBottom: "12px" }}>
              <label>Email Address:</label>
              <input
                type="email"
                {...register("email", { required: "Email is required" })}
                style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                placeholder="Enter email to share"
              />
              {errors.email && (
                <span style={{ color: "red", fontSize: "12px" }}>{errors.email.message}</span>
              )}
            </div>
            <button type="submit" className="approveButton">
              Send
            </button>
          </form>
        </Box>
      </Modal>

    </div>
  );
};

export default ActiveActions;
